module.exports = __webpack_public_path__ + "img/measurements-example2.97c68d1b.jpg";